export const useCallEventsCallbacks = ({ preventDefault, stopPropagation }) => {
  return {
    callEventsCallbacks(e) {
      preventDefault && e?.preventDefault?.();
      stopPropagation && e?.stopPropagation?.();
    },
  };
};
